<template lang="pug">
  form(@submit.prevent="onSubmit")
    div
      p.text-large - Confirme os dados do Documento
      .divider
      section
        h1.h5 Tipo do documento
        .columns
          item-col.my-1.col-12(label="doc.tipo" :value="resource | enums('doc.tipo')")
        .divider
        section
          h1.h5 {{ 'doc.modelo' | tModel }}
          .text-primary {{ resource.modelo.titulo }}
          .text-small {{ resource.modelo.descricao }}
          .mt-2(v-if="!edit")
            router-link.no-decoration.text-small(:to="{name: `${routePreffix}.modelo`}")
              btn-content(name="edit")
      .divider
      section
        h1.h5 Informações do Documento
        .columns
          item-col.my-1.col-12(label="doc.cadastro" :value="resource.cadastro | cadastro")
          item-col.my-1.col-12(label="doc.local" :value="resource.local ? resource.local.cadastro : resource.cadastro | cadastro")
          item-col.my-1.col-12(label="doc.fiscal" :value="resource.fiscal ? resource.fiscal.nome : '-'")
          item-col.my-1.col-12(label="doc.tipo" :value="resource | enums('doc.tipo')")
          item-col.my-1.col-6.col-sm-12(
            label="doc.prazo_regularizar"
            :value="`${resource.prazo_regularizar} ${resource.prazo_regularizar === 1 ? 'dia' : 'dias'}`"
          )
          item-col.my-1.col-6.col-sm-12(
            label="doc.tipo_entrega"
            :value="`enums.db.enum_ciencia_tipo.${resource.tipo_entrega}` | translate"
          )
        .mt-2
          router-link.no-decoration.text-small(:to="{name: `${routePreffix}.info`}")
            btn-content(name="edit")
      .divider
      div(v-if="resource.modelo.params.osm.steps.web.includes('valores')")
        section
          h1.h5 Valores do Documento
          .columns
            item-col.my-1.col-6.col-sm-12(
              v-for="valor in resource.valores"
              :key="valor.tipo"
              :label="valor.titulo"
              :value="valor | formatValor"
            )
          .mt-2
            router-link.no-decoration.text-small(:to="{name: `${routePreffix}.valores`}")
              btn-content(name="edit")
        .divider
      div(v-if="resource.modelo.params.osm.steps.web.includes('irregularidades')")
        section
          h1.h5 Irregularidades do Documento
          div(v-if="resource.irregularidade_codigos_add.length")
            .my-2(v-for="irregularidade in irregularidades")
              small
                i.fa.fa-check
                |  {{ irregularidade.descricao }}
          div(v-else) #[cite Nenhuma irregularidade adicionada]
          .mt-2
            router-link.no-decoration.text-small(:to="{name: `${routePreffix}.irregularidades`}")
              btn-content(name="edit")
        .divider
      section
        h1.h5 Comentários do Documento
        .my-2.p-2.bg-gray.s-rounded(v-for="comentario in resource.comentarios")
          .columns
            item-col.my-1.col-12(label="comentario.descricao" :value="comentario.descricao")
          .columns.col-oneline
            .column.col-3.my-2(v-for="anexo in comentario.anexos" v-if="!anexo._destroy")
              img.img-responsive(:src="anexo.file_info.thumb")
        .mt-2
          router-link.no-decoration.text-small(:to="{name: `${routePreffix}.comentario`}")
            btn-content(name="edit")
      .divider
      section
        h1.h5 Textos do Documento
        .my-2.p-2.bg-gray.s-rounded(v-for="texto in resource.textos")
          .text-center.mb-2 {{ texto.titulo }}
          .text-long {{ texto.descricao }}
      section(v-if='!revisao')
        .divider
        .form-group
          label.form-switch
            input(type="checkbox" v-model="resource._rascunho")
            i.form-icon
            |  Salvar como rascunho
    .pt-2.mb-2.text-right
      .divider
      button.btn.btn-primary(:disabled="loading" :class="{loading}")
        btn-content(name="save")
           
</template>

<script>
import toastErrors from '@/lib/errors/toastErrors'
import mixin from './mixin'

export default {
  vuex: {
    'fiscalizacao/docs': {
      actions: ['fetchCreate', 'fetchUpdate', 'fetchRevisar'],
    },
  },
  data() {
    return { loading: false }
  },
  computed: {
    routePreffix() {
      if (this.edit) return 'fiscalizacao.docs.edit'
      if (this.revisao) return 'fiscalizacao.docs.revisao'
      return 'fiscalizacao.docs.create'
    },
    irregularidades() {
      return this.resource.todas_irregularidades.filter(item => item._selected)
    },
    submitFunction() {
      if (this.edit) return this.fetchUpdate
      if (this.revisao) return this.fetchRevisar

      return this.fetchCreate
    },
  },
  mixins: [mixin],
  methods: {
    async onSubmit() {
      try {
        this.loading = true
        const submitFunction = this.submitFunction
        const { id } = await submitFunction(this.resource.postParams)
        this.$toaster.success('Documento salvo com sucesso')
        this.$router.replace({
          name: 'fiscalizacao.docs.show',
          params: { id },
        })
      } catch (e) {
        toastErrors(e)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
